import { When } from 'react-if';
import { useTranslation } from 'next-i18next';
import { Button } from '@zep/ui';
import { usePrice } from '../../../../../services';
import { FeatureCard } from './FeatureCard';
import S from './PricingFeatures.module.scss';
export const PricingFeatures = () => {
  const {
    data
  } = usePrice({
    suspense: true
  });
  return <section className={S.section} data-sentry-component="PricingFeatures" data-sentry-source-file="PricingFeatures.tsx">
      <div className={S.inner}>
        <When condition={data?.PricingFeatures.list?.length} data-sentry-element="When" data-sentry-source-file="PricingFeatures.tsx">
          <div className={S.list} role="list">
            {data?.PricingFeatures.list?.map((card, index) => <div className={S.item} role="listitem" key={index}>
                <FeatureCard title={card.title} description={card.description} imageUrl={card.imageUrl} imageAlt={card.imageAlt} isPremiumAppButton={card.isPremiumAppButton} />
              </div>)}
          </div>
        </When>
        <DataDashboard data-sentry-element="DataDashboard" data-sentry-source-file="PricingFeatures.tsx" />
      </div>
    </section>;
};
const DataDashboard = () => {
  const {
    t
  } = useTranslation(['subscription']);
  return <div className={S.dashboard_wrapper} data-sentry-component="DataDashboard" data-sentry-source-file="PricingFeatures.tsx">
      <div className={S.text_wrapper}>
        <h1 className={S.title}>
          {t('subscription:pricing.plansEnterprise.dataDashboard')}
        </h1>
        <p className={S.description}>
          {t('subscription:pricing.datadashboard.cardContentDescription')}
        </p>
        <Button as="a" variant={'secondary'} size={'xxs'} href={t('subscription:pricing.datadashboard.buttonLink')} target="_blank" data-sentry-element="Button" data-sentry-source-file="PricingFeatures.tsx">
          {t('subscription:pricing.comparison.detailGuildButtonText')}
        </Button>
      </div>
      <div className={S.image_wrapper}>
        <img src={`/images/pricing/${t('subscription:Pricing.datadashboardSection.imageSrc')}`} alt={'data dashboard img'} />
      </div>
    </div>;
};